import React from "react";
import { Box, Divider, Typography } from "@mui/material";
import CompanyLogo from "./CompanyLogo";
import CloseIconButton from "../../../../shared/components/CloseIconButton";

interface TitleProps {
  name: string | undefined;
  onClose: () => void;
}

const Title = ({ name, onClose }: TitleProps) => {
  return (
    <Box sx={{display: "flex"}}>
      <CompanyLogo src=""/>
      <Box className="ml-4">
        <Typography fontSize={18} fontWeight={500} className="text-18-medium" style={{ color: "#333" }}>
          {name}
        </Typography>
      </Box>
      <CloseIconButton onClose={onClose} />
    </Box>
  );
};
export default Title;
